import { render, staticRenderFns } from "./ProductThumb.vue?vue&type=template&id=ab7735b2&scoped=true"
import script from "./ProductThumb.vue?vue&type=script&lang=js"
export * from "./ProductThumb.vue?vue&type=script&lang=js"
import style0 from "./ProductThumb.vue?vue&type=style&index=0&id=ab7735b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7735b2",
  null
  
)

export default component.exports